<div class="chat-message notAvatar">
  <div class="chat-message__wrapper">
    <div class="chat-message__image">
      <div class="image">
        <ui-icon nameIcon="phone_callback"></ui-icon>
      </div>
    </div>
    <div class="chat-message__info">
      <div class="head">
        <div class="date">{{data.MsgDT | dateMessage}}</div>
      </div>
      <div class="content content--text" [ngClass]="{'isNotRead': !data.MsgIsRead}" *ngIf="data.MsgText" [innerText]="data.MsgText"></div>
    </div>
  </div>
</div>
